//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WordAreaView from "@/components/objects/WordAreaView";
import MapView from "@/components/objects/MapView";
import MapSchemeView from "@/components/objects/MapSchemeView";
import ObjectSnippet from "@/components/objects/ObjectSnippet.vue";
import { Tooltip } from "ant-design-vue";
import "ant-design-vue/es/tooltip/style/index.css"
import EventsShorts from "@/components/objects/public/EventsShorts.vue";
import ShareLinks from "@/components/objects/public/ShareLinks.vue";
import Subscribes from "@/components/objects/public/Subscribes.vue";
import DonateBlock from "@/components/objects/public/DonateBlock.vue";
import LinksEvents from "@/components/objects/public/shared-blocks/links/events/LinksEvents.vue";
import LinksObjects from "@/components/objects/public/shared-blocks/links/objects/LinksObjects.vue";
import TheSwitch from "@/components/objects/public/TheSwitch.vue";
import PropertiesListItem from "@/components/objects/public/PropertiesListItem.vue";
import Attributes from "@/components/objects/public/attrs/Attributes.vue";
import ArtVideoBlockComponent from "@/components/art/public/VideoBlockComponent.vue";
import { AttrsList, PublicObject } from "@/utils/dto/objects.js";
import Button from "@/components/TheButton.vue";
import ScoringModal from "@/components/objects/ScoringModal.vue";
import TheExport from "@/components/objects/public/TheExport.vue"
import debounce from "lodash/debounce";
import intersection from "lodash/intersection";
import isEmpty from "lodash/isEmpty"
import { trackHit, removeTagsFromText } from "@/utils/helpers.js";
import { maxBy } from 'lodash';
import UserPublicAvatar from '@/components/users/UserPublicAvatar.vue'
import LinkedObjectPublic from "@/components/LinkedObjectPublic.vue";

const setContentWidth = () => {
  const element = document.getElementById('object-view');
  if (element === null) return
  const elementWidth = getComputedStyle(element).getPropertyValue('width');
  document.documentElement.style.setProperty('--content-width', elementWidth);
}


export default {
  name: "ObjectView",
  components: {
    // Button,
    ArtVideoBlockComponent,
    Attributes,
    PropertiesListItem,
    // TheSwitch,
    // ObjectsLinksList,
    LinksObjects,
    LinksEvents,
    LinkedObjectPublic,
    // EventsShorts,
    ShareLinks,
    UserPublicAvatar,
    Subscribes,
    DonateBlock,
    ObjectSnippet,
    MapView,
    MapSchemeView,
    // WordAreaView,
    // TheExport,
    'a-tooltip': Tooltip,
    RelatedLinks: () => import('@/components/objects/RelatedLinks.vue'),
    RelatedObjects: () => import('@/components/objects/RelatedObjects.vue'),
    RelatedArticles: () => import('@/components/objects/RelatedArticles.vue'),
  },
  layout: "public_new",
  meta: {
    pageLayoutBg: '#ffffff',
  },
  async asyncData({ params, store, redirect, error, $axios }) {
    let objNotFound = false
    let canEdit = false
    const objResponse = await store.dispatch('objects/publicObject', params['slug'])
      .catch(e => {
        if (e.response?.status === 418) objNotFound = true
      })

    if (objNotFound) {
      return error({ statusCode: 404, humanReadableMessage: 'У нас нет такого объекта. Но вы можете его создать!' })
    }

    const object = {
      user_can_update: false,
      attrs_list: [],
      links_list: [],
      ...new PublicObject({ ...objResponse }).toDict()
    }

    let similarObjects = []
    let excludedObjects = []
    try {
      similarObjects = await store.dispatch('objects/publicObjects', {
        limit: 4,
        order: '-total_score',
        is_about_project: false,
        similarity_id: object.id,
      }).then(r => {
        return r.items.map(obj => {
          return obj
        })
      })

      if (similarObjects.length) {
        excludedObjects = similarObjects.map(obj => obj.id)
      }
    } catch (e) {}

    let latestObjects = []
    try {
      latestObjects = await store.dispatch('objects/publicObjects', {
        limit: 4,
        order: '-total_score',
        is_about_project: false,
        exclude: excludedObjects.length ? excludedObjects.join(',') + ',' + object.id : object.id,
        ...(object?.type?.category ? { category: object.type.category } : {}),
      }).then(r => {
        return r.items.map(obj => {
          return obj
        })
      })
    } catch (e) {}

    try {
      if (params['slug'] !== object.slug && object.slug) return redirect(`/objects/${object.slug}`);
      const object_id = object.id;
      object.attrs_list = object.attrs_list.map(x => new AttrsList(x, false, true))
      object.links_list = object.links_list.filter(x => Array.isArray(x.items) && x.items.length)
      let workAreas = object.images || []
      let mapScheme = object?.map_dynamic?.map_scheme || []
      let freeInfographic = object?.free_infographic

      let forFetch = new Set()

      object.properties.forEach(prop => {
        if (prop.template.value.type === 'object') {
          [...(Array.isArray(prop.value) ? prop.value : [prop.value])].forEach(val => forFetch.add(val))
        }
      })


      if (mapScheme?.polygons?.polygons?.length) {
        const ids = mapScheme.polygons.polygons.filter(x => x.hasOwnProperty('description') && x.description.object_id).map(x => x.description.object_id)

        if (ids.length) {
          const {
            workAreasObjects
          } = await store.dispatch('objects/publicObjects', { ids: ids.join(',') })
            .then(r => {
              return {
                workAreasObjects: r.items,
              }
            })

          await store.dispatch('properties/fetchObjects', {
            vistat_object: ids.join(','),
            is_main: 1,
            limit: ids.length * 2,
            ranging: 1
          }).then(({ items }) => {
            items.forEach(prop => {
              const relatedObj = workAreasObjects.find(x => x.id === prop.vistat_object)
              if (!Array.isArray(relatedObj.properties)) relatedObj.properties = []

              if (prop.template.value.type === 'object' && prop.is_main) {
                prop.value.forEach(val => forFetch.add(val))
              }
              relatedObj.properties.push(prop)
            })
          })

          mapScheme.polygons.polygons = mapScheme.polygons.polygons.map(polygon => {
            if (!polygon.hasOwnProperty('description')) {
              polygon.description = { text: "", object_id: null }
            }

            if (polygon.description.object_id) {
              polygon.description.object = { ...workAreasObjects.find(x => x.id === polygon.description.object_id) }
            } else {
              polygon.description.object = null
            }

            return polygon
          })
        }
      }

      if (workAreas.length) {
        workAreas = await Promise.all(
          workAreas.map(async workArea => {
            const ids = workArea.polygons.polygons.filter(x => x.hasOwnProperty('description') && x.description.object_id).map(x => x.description.object_id)
            const attr_ids = workArea.polygons.polygons.filter(x => x.hasOwnProperty('description') && x.description.attr_id).map(x => [x.description.object_id, x.description.attr_id, x.id])

            if (ids.length) {
              const {
                workAreasObjects
              } = await store.dispatch('objects/publicObjects', { is_about_project: null, ids: ids.join(',') })
                .then(r => {
                  return {
                    workAreasObjects: r.items,
                  }
                })

              await store.dispatch('properties/fetchObjects', {
                vistat_object: ids.join(','),
                is_main: 1,
                limit: ids.length * 2,
                ranging: 1
              }).then(({ items }) => {
                items.forEach(prop => {
                  const relatedObj = workAreasObjects.find(x => x.id === prop.vistat_object)
                  if (!Array.isArray(relatedObj.properties)) relatedObj.properties = []

                  if (prop.template.value.type === 'object' && prop.is_main) {
                    prop.value.forEach(val => forFetch.add(val))
                  }
                  relatedObj.properties.push(prop)
                })
              })

              if (attr_ids.length) {
                await store.dispatch('objects/fetchAttrsOfManyObjects', attr_ids).then(({ items }) => {

                  attr_ids.forEach(([object_id, attr_id, polygon_id]) => {
                    workArea.polygons.polygons.find(x => x.id === polygon_id).attrData = items.find(x => x.obj_id === object_id && x.data.id === attr_id).data
                  })
                })
              }


              workArea.polygons.polygons = workArea.polygons.polygons.map(polygon => {
                if (!polygon.hasOwnProperty('description')) {
                  polygon.description = { text: "", object_id: null }
                }

                if (polygon.description.object_id) {
                  polygon.description.object = { ...workAreasObjects.find(x => x.id === polygon.description.object_id) }

                  if (polygon.description.attr_id && polygon.attrData) {
                    /* Если есть привязанный список */
                    polygon.description.object.properties = null
                    polygon.description.object.label = polygon.description.object.short_label = polygon.attrData.label
                    polygon.description.object.text = polygon.attrData.text
                    polygon.description.object.icon = polygon.attrData.icon
                    polygon.description.object.has_image = polygon.attrData.image_type === 'image'
                    polygon.description.object.relatedAttrId = polygon.attrData.id
                  }

                } else {
                  polygon.description.object = null
                }

                return polygon
              })
            }
            return workArea
          })
        )
      }

      if (freeInfographic) {
        const ids = freeInfographic.polygons.polygons.filter(x => x.hasOwnProperty('description') && x.description.object_id).map(x => x.description.object_id)
        const attr_ids = freeInfographic.polygons.polygons.filter(x => x.hasOwnProperty('description') && x.description.attr_id).map(x => [x.description.object_id, x.description.attr_id, x.id])

        if (ids.length) {
          const {
            freeInfographicObjects
          } = await store.dispatch('objects/publicObjects', { is_about_project: null, ids: ids.join(',') })
            .then(r => {
              return {
                freeInfographicObjects: r.items,
              }
            })

          await store.dispatch('properties/fetchObjects', {
            vistat_object: ids.join(','),
            is_main: 1,
            limit: ids.length * 2,
            ranging: 1
          }).then(({ items }) => {
            items.forEach(prop => {
              const relatedObj = freeInfographicObjects.find(x => x.id === prop.vistat_object)
              if (!Array.isArray(relatedObj.properties)) relatedObj.properties = []

              if (prop.template.value.type === 'object' && prop.is_main) {
                prop.value.forEach(val => forFetch.add(val))
              }
              relatedObj.properties.push(prop)
            })
          })

          if (attr_ids.length) {
            await store.dispatch('objects/fetchAttrsOfManyObjects', attr_ids).then(({ items }) => {

              attr_ids.forEach(([object_id, attr_id, polygon_id]) => {
                freeInfographic.polygons.polygons.find(x => x.id === polygon_id).attrData = items.find(x => x.obj_id === object_id && x.data.id === attr_id).data
              })
            })
          }


          freeInfographic.polygons.polygons = freeInfographic.polygons.polygons.map(polygon => {
            if (!polygon.hasOwnProperty('description')) {
              polygon.description = { text: "", object_id: null }
            }

            if (polygon.description.object_id) {
              polygon.description.object = { ...freeInfographicObjects.find(x => x.id === polygon.description.object_id) }

              if (polygon.description.attr_id && polygon.attrData) {
                /* Если есть привязанный список */
                polygon.description.object.properties = null
                polygon.description.object.label = polygon.description.object.short_label = polygon.attrData.label
                polygon.description.object.text = polygon.attrData.text
                polygon.description.object.icon = polygon.attrData.icon
                polygon.description.object.has_image = polygon.attrData.image_type === 'image'
                polygon.description.object.relatedAttrId = polygon.attrData.id
              }

            } else {
              polygon.description.object = null
            }

            return polygon
          })
        }
      }

      await store.dispatch("objects/fetchAndSaveCache", [...forFetch])

      try {
        if (store.$auth.loggedIn) {
          await store.dispatch('objects/checkCanEdit', object.id).then(status => canEdit = status)
        }
      } catch (e) {

      }

      const relatedArticles = await store.dispatch('art/fetchMaterialsForObject', object.id)
      const relatedLinks = await store.dispatch('objects/fetchRelatedObjects', { slug: object.id, params: { edge_types: 'event' } })
      const relatedObjects = await store.dispatch('objects/fetchRelatedObjects', { slug: object.id, params: { edge_types__nin: 'event', limit: 15 } })

      return {
        object,
        similarObjects,
        latestObjects,
        workAreaList: workAreas,
        freeInfographic,
        categories: await store.dispatch('categories/publicTree'),
        canEdit,
        relatedArticles,
        relatedLinks,
        relatedObjects,
      }
    } catch (e) {
      return redirect('/')
    }
  },
  data() {
    return {
      object: {
        properties: [],
        properties_links: [],
      },
      workAreaList: [],
      freeInfographic: {},
      similarObjects: [],
      latestObjects: [],
      swiper: null,
      categories: [],
      registerViewPromise: null,
      canEdit: false,
    }
  },
  head() {
    return {
      title: this.headTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.headDescription
        },
        { hid: 'og:title', name: 'og:title', content: this.headTitle },
        { hid: 'og:image', name: 'og:image', content: this.headImage },
        { hid: 'og:description', name: 'og:description', content: this.headDescription },
        { hid: 'og:site_name', name: 'og:site_name', content: 'ViStat.ORG - Интерактивная инфографика.' },
      ]
    }
  },
  computed: {
    filteredLatestObjects() {
      if (this.latestObjects.length) {
        if (this.similarObjects.length >= 3) {
          return this.latestObjects.slice(0, 3)
        }

        return this.latestObjects
      }

      return []
    },
    hasMap() {
      return this.object.hasOwnProperty('map') && this.object.map !== null && !isEmpty(this.object.map.geodata)
    },
    hasMapDynamic() {
      return this.object.hasOwnProperty('map_dynamic') && this.object.map_dynamic !== null && !isEmpty(this.object.map_dynamic.map_config.geodata)
    },
    hasMapScheme() {
      return this.object.hasOwnProperty('map_dynamic') && this.object.map_dynamic !== null && this.object.map_dynamic.svg?.length
    },
    hasVideo() {
      const video = this.object?.video
      return Boolean(video && (video.vk_video || video.youtube || video.rutube))
    },
    updatedAt() {
      const date = new Date(this.object.updated_at)
      const day = date.getDate().toLocaleString('ru', { minimumIntegerDigits: 2 })
      const month = (date.getMonth() + 1).toLocaleString('ru', { minimumIntegerDigits: 2 })
      return `${day}.${month}.${date.getFullYear()}`
    },
    createdAt() {
      const date = new Date(this.object.created_at)
      const day = date.getDate().toLocaleString('ru', { minimumIntegerDigits: 2 })
      const month = (date.getMonth() + 1).toLocaleString('ru', { minimumIntegerDigits: 2 })
      return `${day}.${month}.${date.getFullYear()}`
    },
    userCanEdit() {
      return Boolean(this.$auth.loggedIn && this.canEdit)
    },
    userCanCreateInfographic() {
      return Boolean(this.$auth.loggedIn && ['A', 'CA', 'SCE', 'IG'].includes(this.$auth.user.role))
    },
    isStaging() {
      return process.env.isStaging
    },
    hasInfographics() {
      return !!(this.object.images?.length || this.object.attrs_list?.length || this.object.links_list?.length)
    },
    eventsList() {
      return this.object.links_list.filter(x => x.is_event_list)
    },
    headTitle() {
      const hasProperties = !!(this.object.properties.length)
      let title = this.object.label
      if (this.hasInfographics) {
        title += ' - инфографика'
        if (hasProperties) {
          title += ', характеристики'
        }
        title += `${this.object.attrs_list.length ? `, ${this.object.attrs_list[0].label.toLowerCase()}` : ''}`
        title += this.eventsList?.length ? `, ${this.eventsList[0].label.toLowerCase()}` : ''
      } else if (!this.hasInfographics && hasProperties) {
        title += ' - характеристики'
      }
      return title + '.'

    },
    headDescription() {
      const textExtr = removeTagsFromText(this.object.text)
      let text = `${textExtr.split('.')[0].replace(/[&\/\\#+()$~%.'":*?<>{}\<p\>]/g, '')}`
      text += this.object.attrs_list[0] ? `. ${this.object.attrs_list[0].label}` : ''
      text += this.object.attrs_list[1] ? `, ${this.object.attrs_list[1].label.charAt(0).toLowerCase()}${this.object.attrs_list[1].label.slice(1)}` : ''
      text += this.hasInfographics ?
        `. Интерактивная инфографика, схема${this.eventsList && this.eventsList[0] ? `, ${this.eventsList[0].label.toLowerCase()}` : ''}${this.eventsList[1] ? `, ${this.eventsList[1].label.toLowerCase()}` : ''}`
        : ''
      return text + '.'
    },
    headImage() {
      const imgUrl = `/public/object_images_files/first_image/${this.object.id}/`
      const pictoUrl = this.object.attrs_list[0]?.items[0]?.uuid
        ? `/public/object_attrs_files/${this.object.id}/${this.object.attrs_list[0]?.items[0]?.uuid}/`
        : ''
      const iconUrl = this.object.icon
        ? `/admin/icon_files/${this.object.icon}/picto_black/`
        : ''
      if (this.object.has_image) {
        return this.$addServerPath(imgUrl)
      }
      if (pictoUrl) {
        return this.$addServerPath(pictoUrl)
      }
      if (iconUrl) {
        return this.$addServerPath(iconUrl)
      }
      return ''
    },
    showedSplitBorder() {
      return (this.relatedObjects && this.relatedObjects.length || this.relatedArticles && this.relatedArticles.length) && (this.similarObjects.length || this.filteredLatestObjects.length)
    }
  },
  async mounted() {
    trackHit(this.$route.fullPath, this.headTitle, this.$route.meta.referer)
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      window.addEventListener('resize', this.resizeHandler, { passive: true })
      setContentWidth()
      const slug = this.$route.params["slug"]
      this.registerViewPromise = setTimeout(() => {
        this.$store.dispatch('objects/registerView', slug)
      }, 3000)

      if (this.$route.hash && this.object.attrs_list.map(list => list.items.map(x => x.id)).flat().includes(this.$route.hash.replace('#', ''))) {
        window.addEventListener('click', this.highlightClickHandler)
      }
    }
  },
  beforeDestroy() {
    if (this.registerViewPromise) clearTimeout(this.registerViewPromise)
    this.registerViewPromise = null
    window.removeEventListener('resize', this.resizeHandler)
    window.removeEventListener('click', this.highlightClickHandler)
  },
  methods: {
    workAreaReady() {
      this.swiper.updateAutoHeight(0)
    },
    resizeHandler: debounce(setContentWidth, 50),
    highlightClickHandler(event) {
      const targetIDs = this.object.attrs_list.map(list => list.items.map(x => x.id)).flat()
      const closestItem = event.target.closest('li, .item')
      let matchCandidate = [event.target.getAttribute('id')]
      if (closestItem) matchCandidate.push(closestItem.getAttribute('id'))

      if (intersection(targetIDs, matchCandidate.filter(x => x)).length && intersection(matchCandidate.filter(x => x), this.$route.hash.replace('#', '')).length) {
        // Клик по активному элементу, пропускаем
      } else {
        this.$route.meta.noScroll = true
        this.$router.replace({ hash: null }, () => {
          window.removeEventListener('click', this.highlightClickHandler)
        })
        setTimeout(() => {
          this.$route.meta.noScroll = null
        }, 1000)
      }
    },
    showScoring() {
      this.$vfm.show({
        component: ScoringModal,
        bind: {
          label: this.object.label,
          scoring_data: this.object.scoring_data,
          score: this.object.scoring_score ?? '-',
          total_score: this.object.total_score ?? '-',
        }
      })
    }
  },
}
